import { Injectable } from '@angular/core';
import { HttpService } from '../core/services/http.service';

@Injectable({ providedIn: 'root' })
export class PartnersService {

    private accountsUrl = 'partners/general/accounts';
    private allAccountsUrl = 'partners/general/all-accounts';

    constructor(private httpService: HttpService) { }

    accounts(partner: string, account: string) {
        return this.httpService.get(this.accountsUrl, partner, account, true);
    }

    allAccounts(partner: string, account: string) {
        return this.httpService.get(this.allAccountsUrl, partner, account, false);
    }
}
